import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogContentText, 
  DialogActions, 
  Button 
} from "@mui/material";

/**
 * 確認ダイアログ
 */
const ConfirmDialog = ({
  open,
  message,
  onCancel,
  onConfirm,
  title = "登録の確認"
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onCancel}
      PaperProps={{ 
        sx: { 
          borderRadius: 2,
          maxWidth: '400px'
        } 
      }}
    >
      <DialogTitle sx={{ bgcolor: 'primary.light', color: 'primary.contrastText', py: 2 }}>
        {title}
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <DialogContentText sx={{ whiteSpace: 'pre-line' }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button 
          onClick={onCancel} 
          variant="outlined"
          size="large"
        >
          キャンセル
        </Button>
        <Button 
          onClick={onConfirm} 
          variant="contained"
          size="large"
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;